module.exports = __webpack_public_path__ + "img/5448b.622096a2.svg";